import { Loading } from "@/components";
import Modal from "@/components/common/Modal";
import { useAppDispatch, useAppSelector } from "@/hooks";
import { getIsLoading, setIsLoading } from "@/store/appSlice";
import API from "@/utils/api";
import DT from "datatables.net-dt";
import DataTable from "datatables.net-react";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";

DataTable.use(DT);

const Users = () => {
  const dispatch = useAppDispatch();
  const loading = useAppSelector(getIsLoading);
  const [users, setUsers] = useState([]);
  const [userSearch, setUserSearch] = useState<string>("");
  const [status, setStatus] = useState<string>("");
  const [activeUser, setActiveUser] = useState<any>(null);

  const fetchUsers = async () => {
    dispatch(setIsLoading(true));
    try {
      const params = new URLSearchParams();
      params.append("user", userSearch.trim());
      params.append("status", status);
      const response = await API.get(`users?${params.toString()}`);
      const { data } = response.data;
      setUsers(data);
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(setIsLoading(false));
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return (
    <>
      <Helmet>
        <title>ユーザー管理</title>
      </Helmet>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="form-search row g-2 align-items-center">
              <div className="col-auto">
                <label htmlFor="userSearch" className="form-label mb-0">
                  ユーザー検索
                </label>
                <input
                  type="text"
                  id="userSearch"
                  className="form-select"
                  placeholder="検索..."
                  value={userSearch}
                  onChange={(e) => setUserSearch(e.target.value)}
                />
              </div>
              <div className="col-auto">
                <label htmlFor="status" className="form-label mb-0">
                  ステータス
                </label>
                <select
                  id="status"
                  className="form-select"
                  defaultValue="0"
                  value={status}
                  onChange={(e) => {
                    setStatus(e.target.value);
                  }}
                >
                  <option value="">すべて</option>
                  <option value="1">有効</option>
                  <option value="2">承認待ち</option>
                  <option value="3">退会済み</option>
                  <option value="4">一時停止</option>
                </select>
              </div>
              <div className="col-auto">
                <label
                  htmlFor="status"
                  className="form-label mb-0"
                  style={{ color: "#fff" }}
                >
                  .
                </label>
                <button
                  className="btn_submit btn btn-primary"
                  onClick={fetchUsers}
                >
                  検索
                </button>
              </div>
            </div>
            <div className="card">
              <div className="card-body">
                <div className="table-responsive">
                  <div
                    id="example3_wrapper"
                    className="dataTables_wrapper no-footer"
                  >
                    <Loading />
                    {!loading && (
                      <DataTable
                        data={users}
                        className="display"
                        options={{
                          autoWidth: true,
                          rowCallback: (row, data) => {
                            (row as HTMLTableRowElement).onclick = () =>
                              setActiveUser(data);
                          },
                          stripeClasses: [],
                          order: [],
                          searching: false,
                          destroy: true,
                          info: false,
                          paging: true,
                          language: {
                            lengthMenu: "レコード数&nbsp;_MENU_",
                            emptyTable: "データがありません。",
                          },
                          layout: {
                            topStart: null,
                            topEnd: null,
                            bottomStart: "pageLength",
                            bottomEnd: "paging",
                          },
                          columnDefs: [
                            { targets: "_all", className: "text-start" },
                          ],
                        }}
                        columns={[
                          {
                            title: "View",
                            className: "block_mb",
                            orderable: false,
                            data: null,
                            render: (data, type, row) => {
                              return `<i class="flaticon-381-add-1" data-bs-toggle="modal" data-bs-target="#modalDetailUser"></i>`;
                            },
                          },
                          {
                            title: "ユーザーID",
                            data: "id",
                            orderable: true,
                            className: "text-start",
                          },
                          {
                            title: "ニックネーム",
                            data: "nickname",
                            className: "mb_none text-start",
                            orderable: true,
                          },
                          {
                            title: "メールアドレス",
                            data: "email",
                            className: "text-start",
                          },
                          {
                            title: "現在スコア",
                            data: "currentToeicScore",
                            className: "mb_none text-start",
                            orderable: true,
                          },
                          {
                            title: "目標スコア",
                            data: "targetToeicScore",
                            className: "mb_none text-start",
                            orderable: true,
                          },
                          {
                            title: "ステータス",
                            data: "status",
                            className: "mb_none text-start",
                            orderable: true,
                          },
                          {
                            title: "登録日",
                            data: "addDate",
                            className: "mb_none text-start",
                            orderable: true,
                          },
                          {
                            orderable: false,
                            className: "mb_none",
                            data: null,
                            render: (data, type, row) => {
                              return `<div class="d-flex justify-content-center align-items-center">
                                <a href="/users/${row.id}" class="btn btn-primary shadow btn-xs sharp me-1"><i class="fa fa-pencil"></i></a>
                              </div>`;
                            },
                          },
                        ]}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal id="modalDetailUser" title={activeUser ? activeUser.nickname : ""}>
        <ul className="detail_user_mobile">
          {activeUser && (
            <>
              <li>
                <label>ユーザーID</label>
                <span>{activeUser.id ?? ""}</span>
              </li>
              <li>
                <label>ニックネーム</label>
                <span>{activeUser.nickname}</span>
              </li>
              <li>
                <label>メールアドレス</label>
                <span>{activeUser.email}</span>
              </li>
              <li>
                <label>現在スコア</label>
                <span>{activeUser.currentToeicScore}</span>
              </li>
              <li>
                <label>目標スコア</label>
                <span>{activeUser.targetToeicScore}</span>
              </li>
              <li>
                <label>ステータス</label>
                <span>{activeUser.status}</span>
              </li>
              <li>
                <label>登録日</label>
                <span>{activeUser.addDate}</span>
              </li>
              <li>
                <label>Action</label>
                <span>
                  <div className="d-flex justify-content-center align-items-center">
                    <a
                      href={`/users/${activeUser.id}`}
                      className="btn btn-primary shadow btn-xs sharp me-1"
                    >
                      <i className="fa fa-pencil"></i>
                    </a>
                  </div>
                </span>
              </li>
            </>
          )}
        </ul>
      </Modal>
    </>
  );
};

export default Users;
